import { defineManifest } from "@tc/sdk";
export const manifest = defineManifest({
    id: "audits",
    name: "Audits",
    version: "0.1.0",
    tier: "core",
    accent: "brand",
    dependsOn: ["sites"],
    description: "Your own health checks and site visits: build and change them, carry them out on a phone, agree the actions and release them to the site, track every site's score each round, and pay bonuses on the score.",
    permissions: {
        view: "See your sites' audits, tick off their actions and do self-checks",
        perform: "Carry out official audits and release their actions (area managers)",
        manage: "Build and change the company's audits, see every site, set the rounds",
    },
    grants: {
        "Head office": ["view", "perform", "manage"],
        "Area manager": ["view", "perform"],
        "Site manager": ["view"],
        Supervisor: ["view"],
    },
    tasks: [
        { key: "actions-urgent", title: "Urgent audit actions", description: "Urgent actions from a released audit. Tick each one off on the Audits page; clears when they're all done.", level: "urgent", clear: "fix", icon: "flag", sort: 30, link: "/audits", notify: true },
        { key: "actions", title: "Audit actions", description: "Actions from a released audit. Tick each one off on the Audits page; clears when they're all done.", clear: "fix", icon: "flag", sort: 31, link: "/audits", notify: true },
        { key: "release", title: "Audit to release", description: "An official audit you did: agree its actions and release it to the site. Clears once released.", audience: "routed", clear: "fix", icon: "check", sort: 32, link: "/audits" },
        { key: "notice", title: "Audit changed", description: "The company changed an audit. Someone at the site reads what changed and accepts; clears once accepted.", level: "info", clear: "fix", icon: "tasks", sort: 33, link: "/audits", notify: false },
        { key: "due", title: "Health checks due", description: "Sites still without their health check this round, as the deadline gets close. Clears as each is done.", audience: "routed", clear: "fix", icon: "calendar", sort: 34, link: "/audits/manage" },
    ],
    widgets: [
        { key: "round", title: "Health checks this round", description: "Which sites have had their health check this round, their scores, and open actions.", group: "Jobs", size: 1, permission: "view", defaultOn: true, order: 7 },
    ],
    nav: [
        { label: "Audits", path: "/audits", section: "operations", tab: "Audits", tabIcon: "check", permission: "view", icon: "check", order: 4, blurb: "Carry out site audits, see the scores and tick off the actions" },
        { label: "Manage audits", path: "/audits/manage", section: "operations", kind: "settings", permission: "perform", icon: "settings", order: 965, blurb: "Build your audits, set the rounds and see every site" },
    ],
});
